import { TrajectoryFunctionType } from './functions/transition-targets/trajectory-function-type';
import { BoardTimeline } from './model/board-timeline';
import { Language } from './model/enums/language';

export const ACTIVITY_HIERARCHY_TREE_CUTOFF_DEPTH = 2;
export const DEFAULT_AMOUNT_OF_SIGNIFICANT_DIGITS = 6;
export const ECONOMIC_CASE_EXTENSION_LENGTH = 20;
export const DIGITS_INFO_HIGH_DETAIL = '1.0-20';
export const DIGITS_INFO_MEDIUM_DETAIL = '1.0-8';
export const DEFAULT_LANGUAGE: Language = Language.ENGLISH_GB;
export const DEFAULT_TARGET_LEVEL = 0;
export const DEFAULT_TRAJECTORY_FUNCTION_TYPE: TrajectoryFunctionType = TrajectoryFunctionType.LINEAR;
export const DEFAULT_TARGET_PRECISION = 3;
export const POPULATION_VARIABLE_NAME: string = 'population';
export const ASSETS_URL: string = 'https://climateview-assets.azureedge.net/';
export const CDN_URL: string = 'https://cdn.climateview.net/';
export const CDN_FALLBACK_URL: string = 'https://climateboardprod01files.blob.core.windows.net/';
export const TRANSITION_ELEMENT_ASSETS: string = `${ASSETS_URL}transition-element-assets/`;
export const MINUTE_IN_MS: number = 60000;
export const ASSETS_DIRECT_URL: string = 'https://transitiontargetlanguage.blob.core.windows.net/';
export const DEFAULT_HEADER_IMAGE: string = 'https://maplauncher.blob.core.windows.net/b2c/template_landingpage.jpg';
export const DEFAULT_EMISSIONS_PATHWAYS_IMAGE: string =
  'https://climateview-assets.azureedge.net/static-assets/emissions_default.jpg';
export const TERMS_OF_USE_URL: string = 'https://www.climateview.global/terms-and-conditions';
export const PANORAMA_SE = 'ec2d0cdf-e70e-43fb-85cb-ed6b31ee1e09';
export const PANORAMA_EN = '48023530-bb99-4a82-a00e-c9e7aad71f5d';
export const CLEARPATH_STRING: string = 'ClearPath 2.0';
export const CLIMATEVIEW_LINK: string = 'https://www.climateview.global';
export const CLIMATEVIEW_STRING: string = 'ClimateView';
export const GPC_HIERARCHY_NAME: string = 'GPC';
export const GPC_CORPORATE_HIERARCHY_NAME: string = 'gpc_corporate_office';
export const TEF_HIERARCHY_NAME: string = 'tef_activity_hierarchy';
export const TREE_NAME_RESOURCES: string = 'resources';
export const TREE_NAME_SOCIO_ECONOMIC: string = 'socio_economic';
export const TREE_NAME_ECONOMICS: string = 'economics';
export const HIERARCHY_NAME_TE_SUPPLY: string = 'tef_element_supply_hierarchy';
export const ICLEI_DOMAIN: string = 'clearpathicleiusa.org';

export const FALLBACK_LANGUAGE = {
  'en-US': 'en-GB',
  'sv-PA': 'sv-SE',
  'en-PA': 'en-GB',
  'sv-SE': 'en-GB',
  'de-DE': 'en-GB',
  'es-ES': 'en-GB',
  'fr-FR': 'en-GB',
  'nl-NL': 'en-GB',
  'de-CH': 'de-DE',
};

// Timeline constants
export const DEFAULT_BOARD_START_YEAR = 2020;
export const DEFAULT_SCENARIO_START_YEAR = 2020;
export const DEFAULT_BOARD_END_YEAR = 2030;
export const DEFAULT_ACTIVITY_BASED_INVENTORY_START_YEAR = DEFAULT_SCENARIO_START_YEAR;
export const DEFAULT_LATEST_FINALISED_INVENTORY_YEAR = DEFAULT_SCENARIO_START_YEAR;
export const DEFAULT_BOARD_TIMELINE: BoardTimeline = {
  boardStartYear: DEFAULT_BOARD_START_YEAR,
  activityBasedInventoryStartYear: DEFAULT_ACTIVITY_BASED_INVENTORY_START_YEAR,
  scenarioStartYear: DEFAULT_SCENARIO_START_YEAR,
  latestFinalisedInventoryYear: DEFAULT_LATEST_FINALISED_INVENTORY_YEAR,
  boardEndYear: DEFAULT_BOARD_END_YEAR,
};

export const QUERY_PARAMS = {
  SCENARIO_ID: 'scenarioId',
};
